var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35714 0C2.05286 0 1.77062 0.16208 1.61719 0.425223L0.117188 2.99665C0.0409018 3.12779 0 3.27686 0 3.42857V13.7143C0 14.6597 0.768857 15.4286 1.71429 15.4286H7.96708C7.80508 14.8851 7.71429 14.31 7.71429 13.7143H1.71429V5.14286H13.7143V7.71429C14.31 7.71429 14.8851 7.80508 15.4286 7.96708V3.42857C15.4286 3.27686 15.3877 3.12779 15.3114 2.99665L13.8114 0.425223C13.658 0.16208 13.3757 0 13.0714 0H2.35714ZM2.84933 1.71429H12.5792L13.5787 3.42857H1.84989L2.84933 1.71429ZM5.14286 6.85714V8.57143H10.2857V6.85714H5.14286ZM13.7143 9.42857C11.3477 9.42857 9.42857 11.3477 9.42857 13.7143C9.42857 16.0809 11.3477 18 13.7143 18C16.0809 18 18 16.0809 18 13.7143C18 11.3477 16.0809 9.42857 13.7143 9.42857ZM15.4721 11.7003L16.6708 12.9007L13.2857 16.2857L10.7578 13.7578L11.9565 12.5575L13.2857 13.885L15.4721 11.7003Z",
    fill: "#A1A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.82b15abb.svg";
export { ForwardRef as ReactComponent };